import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./api/axios";
import i18n from "./plugins/i18n";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";

require("./assets/css/vendors.css");
require("./assets/css/styles.css");

require("./assets/css/fontawesome.css");
require("./assets/js/vendors");
require("./assets/js/main");

Vue.config.productionTip = false;
Vue.prototype.$http = api;
Vue.prototype.$baseURL =
  process.env.VUE_APP_BASE_URL !== undefined
    ? process.env.VUE_APP_BASE_URL
    : "";
Vue.prototype.$FB_ID = process.env.VUE_APP_FB;
import GAuth from "vue-google-oauth2";
const gauthOption = {
  clientId: process.env.VUE_APP_GD,
  scope: "profile email",
  prompt: "select_account"
};

window.instanciaVue = new Vue();
Vue.use(GAuth, gauthOption);
new Vue({
  router,
  store,
  i18n,
  GAuth,
  gauthOption,
  render: h => h(App)
}).$mount("#app");
